/* eslint-disable no-unused-expressions */

import React from "react";
import { Card, Elevation, HTMLTable } from "@blueprintjs/core";
import ItemThumbnail from "./ItemThumbnail";
import { useUploadedDataStore } from "../../../stores/UploadedDataStore";
import "./NarrationsThumbnail.scss";


const CUSTOM_FIELDS = ['video_uid', 'benchmarks', 'annotations']

function NarrationsThumbnail({ item, setDetailIDs, mode, selectedFields }) {
  const video_uid = selectedFields.includes('video_uid') &&
    <p style={{ fontSize: 12 }}>
      {item.video_uid}
    </p>

  const imageThumbnail = <ItemThumbnail item={item} />;
  const uploadedData = useUploadedDataStore(state => state.uploadedData);
  const matching_uploaded_data = Object.keys(uploadedData).filter(k => !!uploadedData[k][item.video_uid]);

  const uploaded_data_tag = matching_uploaded_data.map(k =>
    <span
      className={"thumbnail-tag customtag-predictions"}>
      {k.replace('.json', '')}
    </span>
  );

  const benchmarks =
    selectedFields.includes('benchmarks') &&
    <span style={{ paddingTop: '5px' }}>
      {
        getBenchmarks(item).map(({ tag, subtag }) => (
          <span
            className={"thumbnail-tag tag-" + tag + " " + (subtag ?? "")}
            key={tag}>
            {tag}
          </span>
        ))
      }
    </span>;

  const annotations = selectedFields.includes('annotations') &&
    <span style={{ paddingTop: '5px' }}>
      {
        (item.annotations ?? []).map((tag) => (
          <span
            className={"thumbnail-tag tag-" + tag.replace(/ /g, "_")}
            key={tag}>
            {tag}
          </span>
        ))
      }
    </span>;

  const rendered_fields =
    <HTMLTable condensed={true} bordered={true} className='thumbnail-detail'>
      <tbody>
        {selectedFields.filter(x => !CUSTOM_FIELDS.includes(x)).map(f =>
          <tr key={f}>
            <th className='thumbnail-detail-label'>{f}:</th>
            <td className='thumbnail-detail-info'>
              {
                item[f] && item[f].constructor === Array
                  ? item[f].map(
                    (x, i) => <span key={`${x}_${i}`}>{i > 0 && <div className='separator' />}{String(x)}</span>
                  )
                  : item[f]
              }
            </td>
          </tr>
        )}
      </tbody>
    </HTMLTable>;

  if (mode === 'mini') {
    return <div className='mini-thumbnail'> {imageThumbnail} </div>
  }
  return (
    <div className="json-item-renderer">
      <Card
        elevation={Elevation.TWO}
        interactive={true}
        className="json-item-card"
      >
        {video_uid}
        {imageThumbnail}
        {benchmarks}
        {annotations}
        {uploaded_data_tag}
        {rendered_fields}
      </Card>
    </div>
  );
}

function getBenchmarks(item) {
  let raw_benchmarks = item.benchmarks || [];
  let tagged_benchmarks = [];
  raw_benchmarks.forEach(benchmark => {
    if ([benchmark + "-train", benchmark + "-val"].filter(v => item.splits.includes(v)).length > 0) {
      tagged_benchmarks.push({ tag: benchmark, subtag: "" });
    } else {
      tagged_benchmarks.push({ tag: benchmark, subtag: "test" });
    }
  });
  return tagged_benchmarks;
}

export { NarrationsThumbnail };
